import {useEffect, useState} from 'react'
import {useLazyQuery, useMutation} from '@apollo/client'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {
  GET_CANTERAS_CREATE_VENTAS,
  GET_CLIENTS_CREATE_VENTAS,
  GET_PRODUCTS_CREATE_VENTAS,
  GET_VENTA_EDIT,
} from '../../graphql/queries/getVentas'
import {Alert, Button, Card, Col, Collapse, Form, Placeholder, Row} from 'react-bootstrap'
import Select from 'react-select'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {InputCurrency} from '../../components/InputCurrency'
import type {
  IDataResCreate,
  IDataResEdit,
  IDataResOneVenta,
  IResCanterasVentas,
  IResClientsVentas,
  IResProductsVentas,
} from '../../graphql/types/ventasType'
import {Spinner} from '../../components/Spinner'
import {CREATE_VENTAS, EDITAR_VENTA} from '../../graphql/mutations/ventaMutations'
import {parseId, parsePrice} from '../../helpers'
import {toast} from 'react-toastify'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {STATUS_VENTA} from '../../helpers/consts'

const validationSchema = Yup.object().shape({
  saleTotal: Yup.string().required('Valor total de la venta es obligatorio'),
  client: Yup.string().required('Cliente es obligatorio'),
  quarry: Yup.string().required('Cantera es obligatoria'),
  products: Yup.array()
    .of(
      Yup.object().shape({
        product: Yup.string().required('El nombre del producto es obligatorio'),
        units: Yup.number().required('Las unidades son obligatorias').min(1, 'Debe ser al menos 1'),
      })
    )
    .required('Se requiere al menos un producto'),
  saleType: Yup.string()
    .required('Tipo de venta es obligatorio')
    .oneOf(['PREPAGO', 'POSTPAGO'], 'Tipo de venta no válido'),
  observations: Yup.string(),
})
interface IInputSend {
  client: string | number
  quarry: string | number
  saleType: string
  saleTotal: string
  products: {
    product: number
    units: number
  }[]
  observations: string
  id?: string
}
interface IObjAdd {
  value: string
  label: string
  price: string
  prevPrice: string
  promotion: string
  isDisabled?: boolean
  isPromotion: boolean
}
interface IProductsInfo {
  name: string
  quantity: number
  id: string
  value: string
  prevValue: string
  isPromotion: boolean
  promotion: string
}

interface ISelect {
  value: string
  label: string
}
interface ISelectPros {
  value: string
  label: string
  isDisabled?: boolean
  price: string
  prevPrice: string
  promotion: string
  isPromotion: boolean
}

export const AddVentaPage = () => {
  const [gqlCreateVenta, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IDataResCreate>(CREATE_VENTAS)
  const [gqlEditVenta, {data: dataEdit, loading: loadingEdit, error: errorEdit}] =
    useMutation<IDataResEdit>(EDITAR_VENTA)

  const [gqlGetVenta, {data: dataVenta, loading: loadingVenta, error: errorVenta}] =
    useLazyQuery<IDataResOneVenta>(GET_VENTA_EDIT, {fetchPolicy: 'no-cache'})

  const [gqlGetClients, {data: dataClients, loading: loadingClients, error: errorClients}] =
    useLazyQuery<IResClientsVentas>(GET_CLIENTS_CREATE_VENTAS, {fetchPolicy: 'no-cache'})
  const [gqlGetCanteras, {data: dataCanteras, loading: loadingCanteras, error: errorCanteras}] =
    useLazyQuery<IResCanterasVentas>(GET_CANTERAS_CREATE_VENTAS, {fetchPolicy: 'no-cache'})
  const [gqlGetProducts, {data: dataProducts, loading: loadingProducts, error: errorProducts}] =
    useLazyQuery<IResProductsVentas>(GET_PRODUCTS_CREATE_VENTAS, {fetchPolicy: 'no-cache'})

  const navigate = useNavigate()
  const [searchParam] = useSearchParams()
  const idVentaEdit = searchParam.get('venta')

  const [clientSelects, setClientSelects] = useState<ISelect[]>([])
  const [canterasSelect, setCanterasSelect] = useState<ISelect[]>([])
  const [productsSelect, setProductsSelect] = useState<ISelectPros[]>([])
  const [selectOneProduct, setSelectOneProduct] = useState<null | {
    label: string
    value: string
    price: string
    prevPrice: string
    promotion: string
    isPromotion: boolean
  }>(null)
  const [unitProduct, setUnitProduct] = useState<{
    value: number | string
    error: null | string
    touched: boolean
  }>({
    value: 1,
    error: null,
    touched: false,
  })
  const [productsInfo, setProductsInfo] = useState<IProductsInfo[]>([])
  const [keySelect, setKeySelect] = useState(Date.now().toString())
  const [errorProductsForm, setErrorProductsForm] = useState<string | null>(null)

  const [loadedProds, setLoadedProds] = useState<null | string[]>(null)

  const formik = useFormik({
    initialValues: {
      client: '',
      quarry: '',
      saleType: 'PREPAGO',
      saleTotal: '',
      products: [] as unknown as {product: number; units: number}[],
      observations: '',
    },
    validationSchema,
    onSubmit(values) {
      const input: IInputSend = {
        ...values,
        client: parseId(values.client),
        quarry: parseId(values.quarry),
      }
      if (productsInfo.length === 0) {
        setErrorProductsForm('Debes seleccionar al menos un producto')
        return
      }
      setErrorProductsForm(null)
      input.products = productsInfo.map(({id, quantity}) => ({
        product: parseId(id),
        units: quantity,
      }))
      console.log('input', input)
      if (dataVenta && dataVenta.saleList.edges.length > 0 && idVentaEdit) {
        const newInput = {
          saleId: idVentaEdit,
          saleTotal: input.saleTotal,
          products: input.products,
          observations: input.observations,
        }
        gqlEditVenta({
          variables: {
            input: newInput,
          },
        })
        return
      }

      gqlCreateVenta({variables: {input}})
    },
  })

  useEffect(() => {
    gqlGetClients()
    gqlGetCanteras()
    gqlGetProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!idVentaEdit) return
    if (!Number(idVentaEdit)) return
    gqlGetVenta({
      variables: {
        id: idVentaEdit,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idVentaEdit])

  useEffect(() => {
    if (!dataClients) return
    if (dataClients.clientList?.edges?.length > 0) {
      setClientSelects(
        dataClients.clientList.edges.map(({node}) => ({
          value: node.id,
          label: `${node.name} - ${node.nit}`,
        }))
      )
    }
  }, [dataClients])
  useEffect(() => {
    if (!dataCanteras) return
    if (dataCanteras.quarryList?.edges?.length > 0) {
      setCanterasSelect(
        dataCanteras.quarryList.edges.map(({node}) => ({
          value: node.id,
          label: node.name,
        }))
      )
    }
  }, [dataCanteras])
  useEffect(() => {
    if (!dataProducts) return
    const {edges} = dataProducts.productList
    if (edges.length === 0) return

    if (formik.values.client === '') {
      setProductsSelect(
        dataProducts.productList.edges.map(({node}) => ({
          value: node.id,
          label: node.name,
          price: Number(node.promotion) ? node.promotion : node.unitPrice,
          prevPrice: '',
          isPromotion: Boolean(Number(node.promotion)),
          promotion: node.promotion,
        }))
      )
      return
    }

    setProductsSelect(
      dataProducts.productList.edges.map(({node}, i) => {
        const obj: IObjAdd = {
          value: node.id,
          label: node.name,
          price: `${Number(node.unitPrice) - Number(node.promotion)}`,
          prevPrice: '',
          isPromotion: Boolean(Number(node.promotion)),
          promotion: node.promotion,
        }
        const find = node.clientproductpriceSet.edges.find(
          ({node: nodeClient}) => nodeClient.client.id === formik.values.client
        )
        if (loadedProds && loadedProds.length > 0) {
          obj.isDisabled = loadedProds.includes(node.id)
        }
        if (!find) return obj

        obj.prevPrice = node.unitPrice
        obj.price = `${Number(find.node.price) - Number(node.promotion)}`

        return obj
      })
    )
  }, [dataProducts, formik.values.client, loadedProds])

  useEffect(() => {
    if (!dataVenta) return
    if (!dataProducts) return

    const ventaNode = dataVenta.saleList.edges[0]

    if (!ventaNode) return

    if (ventaNode.node.status === STATUS_VENTA.ANULADA) {
      navigate('/')
    }

    const newProds = ventaNode.node.saleproductthroughSet.edges.map(({node}) => {
      const obj = {
        name: node.product.name,
        quantity: Number(node.units),
        id: node.product.id,
        value: `${Number(node.price) - Number(node.promotion)}`,
        prevValue: node.price !== node.product.unitPrice ? node.price : '',
        isPromotion: Boolean(Number(node.promotion)),
        promotion: node.promotion,
      }

      return obj
    })
    setProductsInfo(newProds)

    formik.setValues({
      client: ventaNode.node.client.id,
      observations: ventaNode.node.observations,
      products: [],
      quarry: ventaNode.node.quarry.id,
      saleTotal: ventaNode.node.saleTotal,
      saleType: ventaNode.node.saleType,
    })
    setLoadedProds(ventaNode.node.saleproductthroughSet.edges.map(({node}) => node.product.id))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataVenta, dataProducts])

  useEffect(() => {
    if (!errorVenta) return
    toast.error('Error: ' + errorVenta.message)
  }, [errorVenta])
  useEffect(() => {
    if (!errorClients) return
    toast.error('Error: ' + errorClients.message)
  }, [errorClients])
  useEffect(() => {
    if (!errorCanteras) return
    toast.error('Error: ' + errorCanteras.message)
  }, [errorCanteras])
  useEffect(() => {
    if (!errorProducts) return
    toast.error('Error: ' + errorProducts.message)
  }, [errorProducts])

  useEffect(() => {
    setUnitProduct((pre) => ({
      ...pre,
      error: Number(unitProduct.value) < 1 ? 'No puede ser menor a uno' : null,
    }))
  }, [unitProduct.value])

  useEffect(() => {
    if (formik.isSubmitting) {
      setErrorProductsForm((pre) => (productsInfo.length > 0 ? null : pre))
    }
  }, [formik.isSubmitting, productsInfo])

  useEffect(() => {
    let tot = 0
    productsInfo.forEach(({quantity, value}) => {
      tot += Number(quantity) * Number(value)
    })
    formik.setFieldValue('saleTotal', tot > 0 ? tot + '' : '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsInfo])

  useEffect(() => {
    if (!errorCreate) return
    toast.error('Error: ' + errorCreate.message)
  }, [errorCreate])
  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.saleCreate.success) {
      toast.success('Venta creada con éxito')
      formik.resetForm()
      navigate(`/venta/${parseId(dataCreate.saleCreate.sale.id)}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])
  useEffect(() => {
    if (!errorEdit) return
    toast.error('Error: ' + errorEdit.message)
  }, [errorEdit])
  useEffect(() => {
    if (!dataEdit) return
    if (dataEdit.saleUpdate.success) {
      toast.success('Venta actualizada correctamente')
      formik.resetForm()
      navigate(`/venta/${idVentaEdit}`)
    } else if (dataEdit.saleUpdate.errors) {
      toast.error('Error: ' + dataEdit.saleUpdate.errors.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEdit])

  if (loadingProducts || loadingCanteras || loadingClients || loadingVenta) {
    return (
      <div>
        <div className='mb-8'>
          <Placeholder.Button variant='dark' xs={3} animation='wave' size='lg' />
        </div>
        <KTCard>
          <div
            className='d-flex align-items-center justify-content-center'
            style={{height: '60vh'}}
          >
            <Spinner size='40px' />
          </div>
        </KTCard>
      </div>
    )
  }

  return (
    <div>
      <BreadcrumbJeisat
        title={
          Boolean(dataVenta && dataVenta.saleList.edges.length > 0)
            ? 'Editar venta'
            : 'Agregar venta'
        }
        breadcrumb={[
          {
            title: 'Ventas',
            path: '/ventas',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={undefined}
      />
      <KTCard>
        <Form
          className='w-100'
          onSubmit={(e) => {
            e.preventDefault()
            formik.submitForm()
          }}
        >
          <KTCardBody className='py-4 d-flex w-100 align-items-center justify-content-center h-100'>
            <Row className='mt-2'>
              <Col lg='12' className='mb-4'>
                <div className='d-flex w-100 align-items-center gap-2'>
                  <h2>Complete los campos para agregar una venta</h2>
                  {(loadingCanteras || loadingClients || loadingProducts) && (
                    <Spinner size='14px' />
                  )}
                </div>
              </Col>
              <Col lg='6' className='mb-4'>
                <Form.Group controlId='client'>
                  <Form.Label>Seleccione cliente</Form.Label>
                  <Form.Select
                    disabled={Boolean(dataVenta && dataVenta.saleList.edges.length > 0)}
                    onChange={(evt) => {
                      formik.handleChange(evt)
                      setSelectOneProduct(null)
                      setProductsInfo([])
                      setUnitProduct({
                        error: null,
                        touched: false,
                        value: '',
                      })
                      /* if (dataProducts && dataProducts?.productList?.edges?.length > 0) {
                        setProductsSelect(
                          dataProducts.productList.edges.map(({node}) => ({
                            value: node.id,
                            label: node.name,
                            price: node.unitPrice,
                          }))
                        )
                      } */
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.client}
                    isInvalid={formik.touched.client && !!formik.errors.client}
                  >
                    <option value=''>Seleccione una opción</option>
                    {clientSelects.map(({label, value}) => (
                      <option value={value} key={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.client}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg='6' className='mb-4'>
                <Form.Group controlId='quarry'>
                  <Form.Label>Seleccione cantera</Form.Label>
                  <Form.Select
                    disabled={Boolean(dataVenta && dataVenta.saleList.edges.length > 0)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.quarry}
                    isInvalid={formik.touched.quarry && !!formik.errors.quarry}
                  >
                    <option value=''>Seleccione una opción</option>
                    {canterasSelect.map(({label, value}) => (
                      <option value={value} key={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.quarry}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {/* <Col lg='6' className='mb-4'>
                <Form.Group controlId='saleType'>
                  <Form.Label>Tipo de venta</Form.Label>
                  <Form.Select
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.saleType}
                    isInvalid={formik.touched.saleType && !!formik.errors.saleType}
                  >
                    <option value=''>Seleccione una opción</option>
                    <option value='PREPAGO'>Prepago</option>
                    <option value='POSTPAGO'>Postpago</option>
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.saleType}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col> */}

              <Col lg='12' className='mb-4'>
                <Row>
                  <Col lg={Boolean(selectOneProduct) ? '6' : '12'}>
                    <Form.Group controlId='products'>
                      <Form.Label>Productos</Form.Label>
                      <Select
                        isDisabled={formik.values.client === ''}
                        key={keySelect}
                        isClearable
                        placeholder='Seleccione producto'
                        options={productsSelect}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused
                              ? 'grey'
                              : formik.touched.products && !!formik.errors.products
                              ? 'red'
                              : 'gray',
                            padding: '3px',
                          }),
                        }}
                        onBlur={formik.handleBlur}
                        value={selectOneProduct}
                        onChange={(value) => {
                          setSelectOneProduct(value)
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Collapse in={Boolean(selectOneProduct)}>
                      <div>
                        <div>
                          <Form.Label>
                            Ingrese la cantidad de{' '}
                            <span className='text-uppercase fw-semibold'>
                              {selectOneProduct?.label}
                            </span>
                          </Form.Label>
                          <Form.Control
                            type='number'
                            value={unitProduct.value}
                            onChange={(e) => {
                              setUnitProduct((pre) => ({...pre, value: e.target.value}))
                            }}
                            isInvalid={Boolean(unitProduct.error)}
                          />
                          {unitProduct.error && (
                            <div
                              style={{
                                width: '100%',
                                marginTop: '0.5rem',
                                fontSize: '0.95rem',
                                color: '#f1416c',
                              }}
                            >
                              {unitProduct.error}
                            </div>
                          )}
                        </div>
                        {selectOneProduct && (
                          <div className='mt-2 w-100 d-flex justify-content-end'>
                            <Button
                              variant='info'
                              disabled={Boolean(unitProduct.error)}
                              onClick={() => {
                                if (unitProduct.error) return
                                setProductsInfo((pre) => [
                                  ...pre,
                                  {
                                    name: selectOneProduct.label,
                                    quantity: Number(unitProduct.value),
                                    id: selectOneProduct.value,
                                    value: selectOneProduct.price,
                                    prevValue: selectOneProduct.prevPrice,
                                    isPromotion: selectOneProduct.isPromotion,
                                    promotion: selectOneProduct.promotion,
                                  },
                                ])
                                setUnitProduct({
                                  error: null,
                                  touched: false,
                                  value: '',
                                })
                                setProductsSelect((pre) => {
                                  const newArr = [...pre]
                                  const find = newArr.findIndex(
                                    ({label}) => label === selectOneProduct.label
                                  )
                                  if (find < 0) return newArr
                                  newArr[find] = {...pre[find], isDisabled: true}
                                  return newArr
                                })
                                setSelectOneProduct(null)
                                setKeySelect(Date.now().toString())
                              }}
                            >
                              Agregar
                            </Button>
                          </div>
                        )}
                      </div>
                    </Collapse>
                  </Col>
                </Row>
              </Col>

              {productsInfo.length > 0 && (
                <Col lg={12}>
                  <div className='d-flex flex-wrap gap-2 mb-4'>
                    {productsInfo.map((infoProd) => (
                      <div className='card border-dark' key={infoProd.name}>
                        <div className='card-body'>
                          <div className='d-flex justify-content-between align-items-center mb-2'>
                            <h5 className='card-title m-0 p-0'>{infoProd.name}</h5>
                            <button
                              className='border-0 bg-transparent p-0 m-0'
                              title='Eliminar'
                              type='button'
                              onClick={() => {
                                setProductsSelect((pre) => {
                                  const newArr = [...pre]
                                  const findI = newArr.findIndex(
                                    ({label}) => label === infoProd.name
                                  )
                                  if (findI < 0) return newArr
                                  delete newArr[findI].isDisabled
                                  return newArr
                                })
                                setProductsInfo((pre) =>
                                  pre.filter(({name: nameP}) => nameP !== infoProd.name)
                                )
                              }}
                            >
                              <i className='fa fa-solid fa-trash text-danger fs-4' />
                            </button>
                          </div>
                          <p className='card-text'>Cantidad: {infoProd.quantity}</p>
                          <p className='card-text'>Precio unitario: {parsePrice(infoProd.value)}</p>
                          {infoProd.prevValue && (
                            <p style={{color: '#818181'}}>
                              Precio público:{' '}
                              <span style={{textDecoration: 'line-through'}}>
                                {parsePrice(infoProd.prevValue)}
                              </span>
                            </p>
                          )}
                          {infoProd.isPromotion && (
                            <span className='text-warning'>
                              ¡Tiene descuento de {parsePrice(infoProd.promotion)}!
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              )}

              <Col lg='12' className='mb-4'>
                <Form.Group controlId='saleTotal'>
                  <Form.Label>Valor total de la venta</Form.Label>
                  <InputCurrency
                    name='saleTotal'
                    placeholder='Ingrese el valor total'
                    className={`${
                      formik.touched.saleTotal && !!formik.errors.saleTotal ? 'is-invalid' : ''
                    } form-control`}
                    /* onValueChange={(value, name) => {
                      if (name) {
                        formik.setFieldValue(name, value)
                      }
                    }} */
                    readOnly
                    onBlur={formik.handleBlur}
                    value={formik.values.saleTotal}
                  />
                  {formik.touched.saleTotal && !!formik.errors.saleTotal && (
                    <div
                      style={{
                        width: '100%',
                        marginTop: '0.5rem',
                        fontSize: '0.95rem',
                        color: '#f1416c',
                      }}
                    >
                      {formik.errors.saleTotal}
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col lg='12' className='mb-4'>
                <Form.Group controlId='observations'>
                  <Form.Label>Observaciones</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations}
                    isInvalid={formik.touched.observations && !!formik.errors.observations}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.observations}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {errorProductsForm && (
                <Col lg={12}>
                  <Alert variant='warning'>{errorProductsForm}</Alert>
                </Col>
              )}
            </Row>
          </KTCardBody>
          <Card.Footer>
            <div className='w-100 d-flex align-items-center justify-content-end gap-4'>
              {dataVenta && dataVenta.saleList.edges.length > 0 && (
                <Button
                  variant='secondary'
                  type='button'
                  onClick={() => navigate(`/venta/${idVentaEdit}`)}
                >
                  Cancelar
                </Button>
              )}
              <Button
                type='submit'
                disabled={
                  Boolean(selectOneProduct) ||
                  loadingCreate ||
                  loadingProducts ||
                  loadingClients ||
                  loadingVenta ||
                  loadingEdit
                }
                className='d-flex align-items-center gap-1'
              >
                {(loadingCreate || loadingEdit) && <Spinner size='16px' />}
                {Boolean(dataVenta && dataVenta.saleList.edges.length > 0)
                  ? 'Editar venta'
                  : 'Agregar venta'}
              </Button>
            </div>
          </Card.Footer>
        </Form>
      </KTCard>
    </div>
  )
}
